/**
 * What a question card asks on the screen, where that is not the stored question.
 *
 * The drafting rule's question for `scheduling_policy` names buffers, and the hours form has no
 * buffer box. Dawid, terminal picker 2026-10-13 (ledger `d8c226f5`), chose "Card's own sentence":
 * the card asks only what its form takes. The same sentence heads the answered card, so a rep never
 * reads another question above the answer they gave. Screen only: the stored question is unchanged.
 */
export const HOURS_QUESTION = "When do you take calls, with how much notice, and how far ahead?";

/** The question as a card shows it: its own sentence for the hours card, the stored one otherwise. */
export const cardQuestion = (key: string, prompt: string): string =>
  key === "scheduling_policy" ? HOURS_QUESTION : prompt;
